import { Component, Input, Output, EventEmitter, ElementRef, OnInit, AfterViewInit } from '@angular/core';

@Component ({
    selector: 'tog-tab-bar',
    templateUrl: 'tab-bar.template.html',
    styleUrls: ['tab-bar.scss']
})
export class TabBarComponent implements OnInit, AfterViewInit {
    @Input() tabs: string[];
    @Input() smallTabs: boolean = false;
    @Input() currentTab: number = 0;
    @Input() primaryColor: string = '#CBDB29';
    @Output() blur = new EventEmitter();

    @Input() 
    set forceTabSwitch(tab: number) {
      this.updateTab(tab);
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
      this.updateTab(this.currentTab);
    }

    updateTab(index: number) {
        this.currentTab = index;
        this.blur.emit(index);

        // because I can't find an easy way to add a conditional style to a conditional class
        // and small-tabs have a slightly different active class styles. Fun times!
        let tabs = document.getElementsByClassName('tog-tab');
        for (let j = 0; j < tabs.length; j++) {
          let currentTab = tabs[j] as HTMLElement;
          if (j === index) {
            if (this.smallTabs) {
              currentTab.style.borderBottom = '2px solid' + this.primaryColor;
            } else {
              currentTab.style.borderBottom = '3px solid' + this.primaryColor;
            }
          } else {
            currentTab.style.borderBottom = 'none';
          }
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/tab-bar/tab-bar.component.ts